import CryptoJS from "crypto-js";
import { Buffer } from "buffer";

// Shared AES-CBC key expected by the backend for encrypted payloads.
const KEY = CryptoJS.enc.Utf8.parse("ED6C504C24FD3140D42E3BFE9F92E4A1");

const IV_POOL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";

export const toBase64 = (text) => Buffer.from(text, "binary").toString("base64");

export const fromBase64 = (base64) =>
  Buffer.from(base64, "base64").toString("binary");

function shuffle(str) {
  let newStr = "";
  let i = str.length;
  while (i) {
    const rand = Math.floor(Math.random() * i);
    newStr += str.charAt(rand);
    str = str.substring(0, rand) + str.substring(rand + 1);
    i--;
  }
  return newStr;
}

export function generateRandomIv(length) {
  return shuffle(IV_POOL.repeat(5)).substring(0, length);
}

/**
 * Encrypts an object into the `{ data }` request body expected by the API:
 * base64(JSON({ iv: base64(iv), value: AES(JSON(obj)) })).
 */
export function encryptPayload(obj) {
  const iv = generateRandomIv(16);
  const encrypted = CryptoJS.AES.encrypt(
    CryptoJS.enc.Utf8.parse(JSON.stringify(obj)),
    KEY,
    { iv: CryptoJS.enc.Utf8.parse(iv), mode: CryptoJS.mode.CBC }
  );
  const transitMessage = JSON.stringify({
    iv: toBase64(iv),
    value: encrypted.toString(),
  });
  return { data: toBase64(transitMessage) };
}

/** Decodes the base64 envelope (`response.data.data`) without decrypting it. */
export function decodeEnvelope(data) {
  return JSON.parse(fromBase64(data));
}

/** Decrypts an already-decoded envelope `{ iv, value }` into a JS value. */
export function decryptEnvelope(envelope) {
  const decrypted = CryptoJS.AES.decrypt(envelope.value, KEY, {
    mode: CryptoJS.mode.CBC,
    iv: CryptoJS.enc.Utf8.parse(fromBase64(envelope.iv)),
  });
  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

/** Decodes and decrypts an encrypted API response (`response.data.data`). */
export function decryptPayload(data) {
  return decryptEnvelope(decodeEnvelope(data));
}
